import React from 'react';
import { CheckCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const AboutSection = () => {
  const { t } = useLanguage();
  
  const keyPoints = [
    t('about.point1'),
    t('about.point2'),
    t('about.point3')
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="absolute inset-0 bg-yellow-400 rounded-3xl transform rotate-3"></div>
            <img
              src="https://customer-assets.emergentagent.com/job_hippopartners/artifacts/2u1kniu4_hippo%20partners%20about%20us.webp"
              alt="Hippo Partners - Creative Collaboration"
              className="relative rounded-3xl shadow-2xl object-cover w-full h-[500px] transform hover:scale-105 transition-transform duration-500"
            />
          </div>

          {/* Content Side */}
          <div className="space-y-6">
            <div className="inline-block px-4 py-2 bg-yellow-400 text-gray-900 rounded-full text-sm font-bold mb-4">
              {t('about.badge')}
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              {t('about.title')}
              <span className="text-yellow-500"> {t('about.titleHighlight')}</span>
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              {t('about.description1')}
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              {t('about.description2')} <span className="font-bold text-gray-900">{t('about.description2Highlight')}</span> {t('about.description2End')}
            </p>

            <div className="space-y-4 pt-4">
              {keyPoints.map((point, index) => (
                <div key={index} className="flex items-start space-x-3 group">
                  <CheckCircle className="h-6 w-6 text-green-500 flex-shrink-0 mt-1 group-hover:scale-110 transition-transform" />
                  <span className="text-gray-700 text-lg">{point}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;